import PubSub from 'underpub-js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ButtonSecondary = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'atom-ButtonSecondary',
  };

  $.extend(true, this.options, options);
};

ButtonSecondary.prototype.init = function() {
  const self = this;

  self.$text = self.options.$el.find(`.${self.data.baseClass}__text`);
  self.$icon = self.options.$el.find(`.${self.data.baseClass}__icon svg`);
  self.$background = self.options.$el.find(
    `.${self.data.baseClass}__background`,
  );

  gsap.set(self.options.$el, {
    backgroundColor: 'transparent',
  });

  PubSub.subscribe('loaded', () => self.initOnScrollAnimation());
};

ButtonSecondary.prototype.initOnScrollAnimation = function() {
  const self = this;

  gsap
    .timeline({
      delay: 0.15,
      scrollTrigger: {
        trigger: self.options.$el[0],
        start: 'top 95%',
      },
      onComplete: () => {
        self.initOnHoverAnimation();
        self.options.$el.addClass('loaded');
        gsap.set(self.$background, { clearProps: 'all' });
        gsap.set(self.options.$el, { clearProps: 'borderColor' });
      },
    })
    .set(self.$background, {
      right: 'auto',
      left: 0,
    })
    .set(self.options.$el, {
      opacity: 1,
    })
    .fromTo(
      self.$background,
      {
        duration: 0.4,
        ease: 'expo.easeout',
        width: 0,
      },
      {
        width: '100%',
      },
    )
    .from(
      self.$text,
      {
        duration: 0.25,
        ease: 'expo.easeout',
        opacity: 0,
        x: -20,
      },
      '-=.1',
    )
    .from(
      self.$icon,
      {
        duration: 0.3,
        ease: 'expo.easeout',
        opacity: 0,
        xPercent: -70,
        yPercent: 70,
      },
      '-=.1',
    );
};

ButtonSecondary.prototype.initOnHoverAnimation = function() {
  const self = this;

  const hoverTL = gsap
    .timeline({
      paused: true,
      onReverseComplete: () => {
        gsap.set([self.$icon, self.$text, self.$background], {
          clearProps: 'all',
        });
        self.$text.hasClass('hovered') && self.$text.removeClass('hovered');
        self.$icon.hasClass('hovered') && self.$icon.removeClass('hovered');
      },
    })
    .to(self.$background, {
      width: 0,
      duration: 0.35,
      ease: 'expo.easeout',
    })
    .to(
      self.$text,
      {
        duration: 0.3,
        ease: 'expo.easeout',
        opacity: 0,
        x: 20,
      },
      '<',
    )
    .to(
      self.$icon,
      {
        duration: 0.175,
        ease: 'expo.easeout',
        yPercent: -100,
        xPercent: 100,
        opacity: 0,
      },
      '<',
    )
    .add(() => self.$icon.toggleClass('hovered'))
    .add(() => self.$text.toggleClass('hovered'))
    .set(self.$text, {
      x: -20,
    })
    .set(self.$icon, {
      ease: 'expo.easeout',
      yPercent: 150,
      xPercent: -150,
    })
    .to(self.$text, {
      duration: 0.25,
      ease: 'expo.easeout',
      x: 0,
      opacity: 1,
    })
    .to(
      self.$icon,
      {
        duration: 0.3,
        ease: 'expo.easeout',
        yPercent: 0,
        xPercent: 0,
        opacity: 1,
      },
      '-=.15',
    );

  const totalTLDuration = hoverTL.totalDuration();

  let playIsActive = false;
  let reverseIsActive = false;
  let playDelayedCall = false;
  let reverseDelayedCall = false;
  const playTimeScale = 1;
  const reverseTimeScale = 1.6;

  const playHoverTL = () => hoverTL.timeScale(playTimeScale).play();
  const reverseHoverTL = () => hoverTL.timeScale(reverseTimeScale).reverse();

  const handleMouseEnter = () => {
    const currentProgress = hoverTL.progress();
    const timeLeft = (totalTLDuration / playTimeScale) * currentProgress;

    if (reverseDelayedCall !== false) {
      reverseIsActive = false;
      reverseDelayedCall.kill();
    }

    if (hoverTL.isActive() & (timeLeft > 0) & !playIsActive) {
      playIsActive = true;
      playDelayedCall = gsap.delayedCall(timeLeft + 0.1, () => {
        playIsActive = false;
        playHoverTL();
      });
    } else {
      playHoverTL();
    }
  };

  const handleMouseLeave = () => {
    const currentProgress = hoverTL.progress();
    const timeLeft =
      (totalTLDuration / reverseTimeScale) * (1 - currentProgress);

    if (playDelayedCall !== false) {
      playIsActive = false;
      playDelayedCall.kill();
    }

    if (hoverTL.isActive() & (timeLeft > 0) & !reverseIsActive) {
      reverseIsActive = true;
      reverseDelayedCall = gsap.delayedCall(timeLeft + 0.1, () => {
        reverseIsActive = false;
        reverseHoverTL();
      });
    } else {
      reverseHoverTL();
    }
  };

  self.options.$el
    .on('mouseenter', () => handleMouseEnter())
    .on('mouseleave', () => handleMouseLeave());
};

export default ButtonSecondary;
